import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'shortenText'
})
export class ShortenTextPipe implements PipeTransform {

    transform(value: string, from: number, to: number): string {
        if (value !== '') {
            let shortenText = value.split(" ");
            let length: number = shortenText.length;
            shortenText.splice(to);
            return shortenText.join(" ") + (length > to ? ' ..' : '');
        } else return value;

    }

}
